import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-icon",
  "use": "icon-user-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user-icon\"><defs><style type=\"text/css\"></style></defs><path d=\"M754.5 641.9c-60.3 62-146.4 100.7-242 100.7-96.7 0-183.6-39.6-244-102.7-108.7 70-185 185.9-201.6 320.4h886.2c-16.5-133.2-91.5-248.2-198.6-318.4z\" p-id=\"6952\" /><path d=\"M512.1 366.6m-302.4 0a302.4 302.4 0 1 0 604.8 0 302.4 302.4 0 1 0-604.8 0Z\" p-id=\"6953\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol